import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nostripartner',
  templateUrl: './nostripartner.component.html',
  styleUrls: ['./nostripartner.component.scss']
})
export class NostripartnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/nostripartner/nostripartner.component.ts